function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.8401 3.00751C16.8401 1.83955 15.8922 0.891634 14.7242 0.891634H3.61588C2.44791 0.891634 1.5 1.83955 1.5 3.00751V20.9925C1.5 22.1604 2.44791 23.1084 3.61588 23.1084H14.7242C15.8922 23.1084 16.8401 22.1604 16.8401 20.9925V16.6549C16.8401 16.0699 16.3672 15.597 15.7822 15.597C15.1982 15.597 14.7242 16.0699 14.7242 16.6549V20.4635C14.7242 20.7555 14.4873 20.9925 14.1953 20.9925H4.14485C3.85286 20.9925 3.61588 20.7555 3.61588 20.4635V3.53648C3.61588 3.24449 3.85286 3.00751 4.14485 3.00751H14.1953C14.4873 3.00751 14.7242 3.24449 14.7242 3.53648V7.34507C14.7242 7.92905 15.1982 8.403 15.7822 8.403C16.3672 8.403 16.8401 7.92905 16.8401 7.34507V3.00751ZM19.7333 8.89862C19.3603 8.52556 18.8629 8.52556 18.4898 8.89862C18.3033 9.08515 18.2405 9.27106 18.2405 9.51977L18.2411 10.6396C18.2405 10.7633 18.1161 10.8877 17.9924 10.8883H9.16323C8.54146 10.8883 8.04404 11.3857 8.04404 12.0075C8.04404 12.6293 8.54146 13.1267 9.16323 13.1267H17.9924C18.1161 13.126 18.2405 13.2504 18.2411 13.3754L18.2405 14.4939C18.2411 14.7433 18.3033 14.9298 18.4898 15.1163L18.5898 15.2084C18.6509 15.2576 18.7257 15.3025 18.8007 15.3029C19.111 15.4888 19.4846 15.365 19.7333 15.1163L22.2204 12.6293C22.5935 12.2562 22.5929 11.7581 22.2204 11.3857L19.7333 8.89862Z",
  fill: "currentcolor"
});

var _ref2 = /*#__PURE__*/React.createElement("script", {
  xmlns: ""
});

var _ref3 = /*#__PURE__*/React.createElement("script", {
  xmlns: ""
});

const SvgLogout = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 25",
  fill: "none",
  ref: svgRef
}, props), _ref, _ref2, _ref3);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogout, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/logout.cfaac9f7.svg";
export { ForwardRef as ReactComponent };